(ns ui.view.card.attachments.model)

(def folders-states-path [:folder-states])

(def folder-expanded-path [:expanded?])

(defn folder-expanded-full-path
  [card-state-path folder-name]
  (vec
   (concat
    card-state-path
    folders-states-path
    [folder-name]
    folder-expanded-path)))

(defn upload-in-progress-full-path
  [card-state-path token]
  (into card-state-path [:uploads-in-progress token]))

(defn upload-in-progress-progress-full-path
  [card-state-path token]
  (-> card-state-path
      (upload-in-progress-full-path token)
      (conj :progress)))
